export default __webpack_public_path__ + "static/media/2023.b8543072.pdf";